import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#69005b',
  width = '100%',
  className = '',
  viewBox = '0 0 102.834 85.057',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Grupo_6003" data-name="Grupo 6003" transform="translate(-246 -343.883)">
      <path
        id="leaf-solid"
        className="icon"
        d="M21.463.358A.61.61,0,0,0,20.353.31a6.722,6.722,0,0,1-5.876,3.43H11.342a7.528,7.528,0,0,0-7.526,7.526,7.751,7.751,0,0,0,.059.8A18.754,18.754,0,0,1,15.1,8.758a.627.627,0,1,1,0,1.254c-9.854,0-14.033,6.04-14.958,8.31a1.256,1.256,0,0,0,2.324.953,10.313,10.313,0,0,1,2.818-3.551,7.509,7.509,0,0,0,6.856,3.026C18.3,18.3,22.631,12.783,22.631,6.026A14.254,14.254,0,0,0,21.463.358Z"
        transform="translate(256.868 343.906)"
        fill={fill}
      />
      <path
        id="leaf-solid-2"
        className="icon"
        data-name="leaf-solid"
        d="M21.463.358A.61.61,0,0,0,20.353.31a6.722,6.722,0,0,1-5.876,3.43H11.342a7.528,7.528,0,0,0-7.526,7.526,7.751,7.751,0,0,0,.059.8A18.754,18.754,0,0,1,15.1,8.758a.627.627,0,1,1,0,1.254c-9.854,0-14.033,6.04-14.958,8.31a1.256,1.256,0,0,0,2.324.953,10.313,10.313,0,0,1,2.818-3.551,7.509,7.509,0,0,0,6.856,3.026C18.3,18.3,22.631,12.783,22.631,6.026A14.254,14.254,0,0,0,21.463.358Z"
        transform="translate(326.203 366.227)"
        fill={fill}
      />
      <path
        id="wind-solid"
        className="icon"
        d="M28.073,72.162H2.866A2.875,2.875,0,0,0,0,75.028v5.733a2.875,2.875,0,0,0,2.866,2.866H28.342a5.984,5.984,0,0,1,5.984,4.765A5.742,5.742,0,0,1,23.218,91.17,2.83,2.83,0,0,0,20.5,89.36H14.619a2.851,2.851,0,0,0-2.849,3.3A17.2,17.2,0,0,0,45.7,87.1C44.609,78.432,36.8,72.162,28.073,72.162ZM2.866,66.429h60.2A17.2,17.2,0,1,0,46.186,45.951a2.824,2.824,0,0,0,2.831,3.279h5.876a2.814,2.814,0,0,0,2.723-1.809A5.742,5.742,0,0,1,68.723,50.2a5.97,5.97,0,0,1-5.984,4.765H2.866A2.875,2.875,0,0,0,0,57.829v5.733A2.875,2.875,0,0,0,2.866,66.429Zm68.795,5.733h-28a22.646,22.646,0,0,1,7.13,11.466H71.661a8.6,8.6,0,1,1-7.453,12.827,2.965,2.965,0,0,0-2.6-1.362H55.555a2.871,2.871,0,0,0-2.741,3.78A20.042,20.042,0,1,0,71.661,72.162Z"
        transform="translate(246 316.649)"
        fill={fill}
        opacity="0.8"
      />
    </g>
  </svg>
);

export default SVG;
